"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSkillKey = extractSkillKey;
exports.extractSkillLabel = extractSkillLabel;
function extractSkillKey(activity) {
    const config = activity.config || {};
    switch (activity.type) {
        case 'letter_tracing':
        case 'letter_formation':
            return `letter:${String(config.targetText || config.characters?.[0] || 'unknown').toLowerCase()}`;
        case 'copy_writing':
            return `copy:${String(config.targetText || 'unknown').toLowerCase().slice(0, 20)}`;
        case 'dictation':
            return `dictation:${String(config.targetText || 'unknown').toLowerCase().slice(0, 20)}`;
        case 'spelling':
        case 'common_exception_words':
            return `spelling:${String(config.word || 'unknown').toLowerCase()}`;
        case 'sentence_building':
            return `sentence:${String(config.sentence || 'unknown').toLowerCase().slice(0, 30)}`;
        case 'maths':
            return `maths:${String(config.expression || 'unknown').replace(/\s+/g, '')}`;
        case 'reading_comprehension':
            return `comprehension:${String(config.prompt || 'unknown').toLowerCase().slice(0, 30)}`;
        case 'independent_writing':
        case 'typed_composition':
            return `writing:${String(config.prompt || 'free').toLowerCase().slice(0, 30)}`;
        case 'science_observation':
            return `science:${String(config.prompt || 'unknown').toLowerCase().slice(0, 30)}`;
        case 'history_source':
            return `history:${String(config.question || 'unknown').toLowerCase().slice(0, 30)}`;
        case 'geography_fieldnote':
            return `geography:${String(config.prompt || 'unknown').toLowerCase().slice(0, 30)}`;
        case 'art_design_sketch':
            return `art:${String(config.prompt || 'unknown').toLowerCase().slice(0, 30)}`;
        case 'computing_design':
            return `computing:${String(config.prompt || 'unknown').toLowerCase().slice(0, 30)}`;
        case 're_reflection':
            return `re:${String(config.prompt || 'unknown').toLowerCase().slice(0, 30)}`;
        case 'interactive_story':
            return `story:${String(activity.id).slice(0, 8)}`;
        case 'story_reader':
            return `story_reader:${String(activity.id).slice(0, 8)}`;
        case 'flashcard_review':
            return 'flashcard:completion';
        default:
            return `${activity.type}:generic`;
    }
}
function extractSkillLabel(activity) {
    const config = activity.config || {};
    switch (activity.type) {
        case 'letter_tracing':
        case 'letter_formation':
            return `Letter ${String(config.targetText || config.characters?.[0] || '').toUpperCase()}`;
        case 'copy_writing':
            return 'Copy Writing';
        case 'dictation':
            return 'Dictation';
        case 'spelling':
            return `Spelling: ${String(config.word || '').toUpperCase()}`;
        case 'common_exception_words':
            return `Tricky Word: ${String(config.word || '').toUpperCase()}`;
        case 'sentence_building':
            return 'Sentence Building';
        case 'maths':
            return `Maths: ${String(config.expression || '')}`;
        case 'reading_comprehension':
            return 'Reading Comprehension';
        case 'independent_writing':
            return 'Independent Writing';
        case 'typed_composition':
            return 'Typed Composition';
        case 'science_observation':
            return 'Science Observation';
        case 'history_source':
            return 'History Source';
        case 'geography_fieldnote':
            return 'Geography Fieldnote';
        case 'art_design_sketch':
            return 'Art & Design';
        case 'computing_design':
            return 'Computing Design';
        case 're_reflection':
            return 'RE Reflection';
        case 'interactive_story':
            return 'Interactive Story';
        case 'story_reader':
            return 'Story Reader';
        case 'flashcard_review':
            return 'Flashcard Review';
        default:
            return activity.type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    }
}
